import { TransactionsContext } from '@views/contexts'
import { useContext } from 'react'

export const useTransactions = () => useContext(TransactionsContext)
